import React from "react";
/**
 * Render an `option` element.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
export function Option(props) {
    return React.createElement("option", { ...props });
}
//# sourceMappingURL=Option.js.map